import { Component, OnInit, Input } from '@angular/core';

import { Recapture } from '../../core/models';
import { RecapturesHelper } from '../../core/helpers';
import { Sort } from '@angular/material/sort';
import { FilterRecapture } from '@app/core/models/common/filter-recapture';

@Component({
  selector: 'app-recaptures-list',
  templateUrl: './recaptures-list.component.html',
  styleUrls: ['./recaptures-list.component.scss'],
})
export class RecapturesListComponent implements OnInit {
  public columns = [
    'RecapturedTime',
    'RecapturedFactory',
    'RecapturedArea',
    'ReleasedICES',
    'ReleasedYear'
  ]

  private _recaptures: Recapture[] = [];
  private _recapturesFilter: FilterRecapture;

  @Input()
  set recaptures(recaptures: Recapture[]) {
    if (recaptures) {
      this._recaptures = recaptures;
      this.recapturesHelper.recaptures = recaptures;
      this.sortedData = this._recaptures.slice();
    }
  }

  @Input()
  set recapturesFilter(filter: FilterRecapture) {
    this._recapturesFilter = filter;
    if (filter && this._recaptures) {
      this.filterRecaptures(filter);
    }
  }

  sortedData: any;
  recapturesHelper: RecapturesHelper;

  constructor() {
    this.sortedData = this._recaptures.slice();
    this.recapturesHelper = new RecapturesHelper();
  }

  ngOnInit() {
  }

  sortData(sort: Sort) {
    let data = this._recaptures.slice();
    if (!sort.active || sort.direction == '') {
      this.sortedData = data;
      return;
    }

    this.sortedData = data.sort((a, b) => {
      let isAsc = sort.direction == 'asc';
      switch (sort.active) {
        case 'Date': return compare(a.RecapturedTime, b.RecapturedTime, isAsc);
        case 'RecapturedFactory': return compare(a.RecapturedFactory, b.RecapturedFactory, isAsc);
        case 'RecapturedArea': return compare(a.RecapturedArea, b.RecapturedArea, isAsc);
        case 'ReleasedICES': return compare(a.ReleasedICES, b.ReleasedICES, isAsc);
        case 'ReleasedYear': return compare(a.ReleasedYear, b.ReleasedYear, isAsc);
        default: return 0;
      }
    });
  }

  filterRecaptures(filter: FilterRecapture) {
    this._recaptures = this.recapturesHelper.findRecaptures(filter);
    this.sortedData = this._recaptures.slice();
  }

  trackByFn(index: any, item: any) {
    return index;
  }
}

function compare(a, b, isAsc) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
